import { useState } from "react";
import FadeIn from "../ui/FadeIn";
import emailjs from "@emailjs/browser";
import { SERVICES, CONTACT_ITEMS } from "../../data/constants";
import styles from "./Contact.module.css";



const EMAILJS_SERVICE_ID = "service_01vv36h";
const EMAILJS_TEMPLATE_ID = "template_0e8wyrr";
const EMAILJS_PUBLIC_KEY = "FXd7M7infwNvg2AkG";


export default function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "",  service: "", message: "" });
  const [formSent, setFormSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // The template variables below must match the ones you set up
    // in your EmailJS template. Use these exact names in EmailJS:
    // {{from_name}}, {{from_email}}, {{phone}}, {{service}}, {{message}}
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      service:    formData.service || "Not specified",
      message:    formData.message,
      reply_to:   formData.email,
    };

    emailjs
      .send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setLoading(false);
        setFormSent(true);
        setFormData({ name: "", email: "", phone: "", service: "", message: "" });
      })
      .catch((err) => {
        setLoading(false);
        setError("Something went wrong. Please try again or contact us via WhatsApp.");
        console.error("EmailJS error:", err);
      });
  };

  return (
    <section id="contact" className={styles.section}>
      <div className="section-wrap">
        <FadeIn>
          <div className={styles.header}>
            <div className="sec-label">Reach Out</div>
            <h2 className="sec-title">Get in Touch</h2>
          </div>
        </FadeIn>

        <div className={styles.grid}>
          {/* Info column */}
          <FadeIn>
            <img
              className={styles.officeImg}
              src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80"
              alt="Nairobi city centre"
            />
            <div className={styles.infoList}>
              {CONTACT_ITEMS.map((item) => (
                <div key={item.heading} className={styles.infoRow}>
                  <div className={styles.infoIcon}>{item.icon}</div>
                  <div>
                    <h4 className={styles.infoHead}>{item.heading}</h4>
                    <p className={styles.infoDetail}>
                      {item.detail.split("\n").map((line, i, arr) => (
                        <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
                      ))}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </FadeIn>

          {/* Form column */}
          <FadeIn delay={0.15}>
            {formSent ? (
              <div className={styles.success}>
                ✓ Thank you, {formData.name}. A member of our team will be in contact shortly.
              </div>
            ) : (
              <form className={styles.form} onSubmit={handleSubmit} noValidate>
                <input name="name" className={styles.field} placeholder="Full Name" required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                <input name="email" type="email" className={styles.field} placeholder="Email Address" required value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                <select name="service" className={styles.field} value={formData.service} onChange={e => setFormData({ ...formData, service: e.target.value })}>
                  <option value="" disabled>Select Service of Interest</option>
                  {SERVICES.map((s) => <option key={s.title} value={s.title}>{s.title}</option>)}
                  <option value="Overseas Career Placement">Overseas Career Placement</option>
                </select>
                <textarea name="message" className={styles.field} placeholder="Your Message" value={formData.message} onChange={e => setFormData({ ...formData, message: e.target.value })} />
                <div style={{
                      fontFamily: "var(--font-sans)", fontSize: "0.85rem", color: "#c0392b",
                      background: "#fdf0ef", border: "1px solid #f5c6c2",
                      padding: "12px 16px", lineHeight: 1.6,
                    }}>{error}</div>
                  

                <button type="submit" className="btn-red" style={{ alignSelf: "flex-start", opacity: loading ? 0.7 : 1, transition: "opacity 0.2s" }}
                    disabled={loading}>Send Message</button>
              </form>
            )}
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
